var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBoxChecked = function SvgBoxChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 29
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.445,
    d: "M6.277.676h15.446c1.706 0 3.803 1.864 4.683 4.162L28 9H0l1.594-4.162C2.474 2.54 4.57.676 6.277.676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.163.698V9H28v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V9h13.108V.698zm5.128 13a1.708 1.708 0 0 0-1.142.475c-2.592 2.454-4.589 4.513-6.963 6.81l-2.414-1.93a1.728 1.728 0 0 0-1.224-.398 1.695 1.695 0 0 0-1.155.552c-.29.324-.43.745-.385 1.168.043.422.267.81.619 1.074l3.598 2.877c.66.529 1.639.49 2.25-.09 2.986-2.828 5.109-5.084 8.027-7.848.488-.451.633-1.14.365-1.735-.267-.594-.893-.973-1.576-.954"
  }))));
};
export default SvgBoxChecked;